var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 30,
    viewBox: "0 0 33 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6571 3.85554C26.5336 0.60935 21.4596 0.60935 18.3228 3.85554L16.9998 5.23313L15.6768 3.85554C12.5534 0.60935 7.47929 0.60935 4.34258 3.85554C1.21914 7.10174 1.21914 12.3527 4.34258 15.5993L16.9727 28.707L17 28.6797L17.0273 28.707L29.6574 15.5993C32.7809 12.3531 32.7809 7.1021 29.6574 3.85554H29.6571Z",
    fill: "#5A8C8D",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5476 5.94977C24.9447 3.24461 20.7163 3.24461 18.1024 5.94977L16.9998 7.09776L15.8973 5.94977C13.2945 3.24461 9.06608 3.24461 6.45215 5.94977C3.84928 8.65493 3.84928 13.0308 6.45215 15.7362L16.9773 26.6593L17 26.6366L17.0227 26.6593L27.5479 15.7362C30.1507 13.0311 30.1507 8.65523 27.5479 5.94977H27.5476Z",
    fill: "#9B7BD0",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.438 8.04399C23.3557 5.87987 19.973 5.87987 17.8819 8.04399L16.9999 8.96239L16.1179 8.04399C14.0356 5.87987 10.6529 5.87987 8.56172 8.04399C6.47943 10.2081 6.47943 13.7088 8.56172 15.8732L16.9818 24.6116L17 24.5935L17.0182 24.6116L25.4383 15.8732C27.5206 13.709 27.5206 10.2084 25.4383 8.04399H25.438Z",
    fill: "#5A8C8D",
    fillOpacity: 0.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3285 10.1382C21.7668 8.51512 19.2298 8.51512 17.6614 10.1382L16.9999 10.827L16.3384 10.1382C14.7767 8.51512 12.2396 8.51512 10.6713 10.1382C9.10957 11.7613 9.10957 14.3868 10.6713 16.0101L16.9864 22.564L17 22.5503L17.0136 22.564L23.3287 16.0101C24.8904 14.387 24.8902 11.7615 23.3285 10.1382Z",
    fill: "#9B7BD0",
    fillOpacity: 0.4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4179 11.908C20.3119 10.7585 18.5153 10.7585 17.4046 11.908L16.9362 12.3957L16.4677 11.908C15.3618 10.7585 13.5651 10.7585 12.4545 11.908C11.3485 13.0574 11.3485 14.9167 12.4545 16.0662L16.9266 20.7075L16.9363 20.6978L16.9459 20.7075L21.418 16.0662C22.524 14.9168 22.5239 13.0575 21.4179 11.908Z",
    fill: "#3F5497",
    fillOpacity: 0.4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9393 13.3739C19.1977 12.6032 17.9931 12.6032 17.2484 13.3739L16.9343 13.701L16.6201 13.3739C15.8786 12.6032 14.6739 12.6032 13.9292 13.3739C13.1877 14.1446 13.1877 15.3913 13.9292 16.1621L16.9278 19.2741L16.9343 19.2676L16.9408 19.2741L19.9394 16.1621C20.6809 15.3914 20.6808 14.1447 19.9393 13.3739Z",
    fill: "#5A8C8D",
    fillOpacity: 0.4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4646 14.8399C18.0874 14.4479 17.4747 14.4479 17.096 14.8399L16.9362 15.0062L16.7765 14.8399C16.3993 14.4479 15.7866 14.4479 15.4079 14.8399C15.0307 15.2319 15.0307 15.8659 15.4079 16.2579L16.933 17.8407L16.9362 17.8374L16.9395 17.8407L18.4646 16.2579C18.8418 15.866 18.8417 15.2319 18.4646 14.8399Z",
    fill: "#5A8C8D",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart4);
export default __webpack_public_path__ + "static/media/Heart-4.32c5ff054fd166288066499c4e101fb4.svg";
export { ForwardRef as ReactComponent };